import { styled } from '@mui/material';

export const Th = styled('th')(({ width }: { width?: string }) => ({
  textAlign: 'left',
  height: 52,
  width,
}));
